import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

type ToastType = "error" | "success" | "info" | "warning";

export const useRedirectWithToast = (
  path: string,
  message: string,
  type: ToastType = "error",
) => {
  const navigate = useNavigate();
  return useCallback(() => {
    navigate(path, {
      replace: true,
      state: { showToast: { message, type } },
    });
  }, [navigate, path, message, type]);
};
